<template lang="pug">
div
  v-chart(class="chart"
    :option="options"
    :autoresize="true"
    :theme="$vuetify.theme.dark ? 'dark' : 'light'")
</template>

<script setup lang="ts">import { computed as _computed } from 'vue';

import VChart from 'vue-echarts';
import { AssetUsageDto } from '@/api';
import dayjs from 'dayjs';

interface ChartUsageProps {
  usageData: AssetUsageDto;
}

const props = defineProps({
  usageData: null
});

const toFormatedDate = (aTimestampDay: number) => dayjs(aTimestampDay).tz().format('YYYY-MM-DD');

const usagePerPersons = _computed(() => props.usageData.usagePerDatasourceUsers.map(
    (usagePErPerson) => ({
      value: usagePErPerson.countRead,
      name: usagePErPerson.userName,
    }),
  ));

const options = _computed(() => ({
    title: {
      text: `Between ${toFormatedDate(props.usageData.startDay)} and ${toFormatedDate(
        props.usageData.endDay,
      )}`,
    },
    tooltip: {
      trigger: 'item',
      appendToBody: true,
      confine: false,
    },
    series: [
      {
        name: 'Usage per user',
        type: 'pie',
        radius: ['0%', '70%'],
        avoidLabelOverlap: true,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2,
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
          },
        },
        labelLine: {
          show: true,
        },
        data: usagePerPersons.value,
      },
    ],
  }));
</script>

<style lang="scss" scoped>
.chart {
  height: 390px;
}
</style>
